var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "cvstyling border-0", attrs: { "no-body": "" } },
    [
      _c(
        "b-card-header",
        {
          staticClass:
            "border-bottom-0 headline-very-small text-uppercase font-weight-bold text-brand-dark pb-0",
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "mr-auto", attrs: { cols: "auto" } },
                    [
                      _vm._v(
                        _vm._s(_vm.t.CV_Tool_Content_Styling) +
                          " " +
                          _vm._s(
                            this.showColorTheme
                              ? "[" +
                                  (_vm.haveExtraMotivationalStep
                                    ? _vm.setupStep
                                    : _vm.setupStep === 3
                                    ? _vm.setupStep - 1
                                    : _vm.setupStep) +
                                  "/" +
                                  (_vm.haveExtraMotivationalStep ? "3" : "2") +
                                  "]"
                              : ""
                          )
                      ),
                    ]
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("ArrowNavigation", {
                        on: {
                          click: function ($event) {
                            return _vm.changeSection($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.setupStep === 1
        ? [
            _c(
              "b-card-body",
              [
                _c("b-card-title", { staticClass: "h5" }, [
                  _vm._v(_vm._s(_vm.t.CV_Tool_Select_Content)),
                ]),
                _c("b-card-text", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.t.CV_Tool_Content_Description)),
                ]),
                _c(
                  "b-overlay",
                  {
                    attrs: {
                      show:
                        _vm.previewUrls !== undefined &&
                        _vm.previewUrls.length === 0,
                      opacity: "0.7",
                    },
                  },
                  [
                    _c(
                      "section",
                      { staticClass: "mt-5" },
                      [
                        _c("h6", { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.t.CV_Tool_Language)),
                        ]),
                        _c("b-select", {
                          attrs: { options: _vm.langOptions },
                          on: { change: _vm.selectLang },
                          model: {
                            value: _vm.selectedLang,
                            callback: function ($$v) {
                              _vm.selectedLang = $$v
                            },
                            expression: "selectedLang",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "section",
                      { staticClass: "mt-5" },
                      [
                        _c("h6", { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.t.CV_Tool_Add_Profile)),
                        ]),
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "b-form-radio-group",
                              {
                                attrs: { stacked: "" },
                                model: {
                                  value: _vm.selectedTemplate,
                                  callback: function ($$v) {
                                    _vm.selectedTemplate = $$v
                                  },
                                  expression: "selectedTemplate",
                                },
                              },
                              [
                                _c(
                                  "b-form-radio",
                                  {
                                    staticClass: "mb-3",
                                    attrs: {
                                      value: _vm.templateOptions[0].value,
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.templateOptions[0].text))]
                                ),
                                _c(
                                  "b-form-radio",
                                  {
                                    staticClass: "mb-3",
                                    attrs: {
                                      value: _vm.templateOptions[1].value,
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.templateOptions[1].text))]
                                ),
                                _c("hr"),
                                _c(
                                  "div",
                                  { staticClass: "cv-examples" },
                                  [
                                    _c(
                                      "b-form-radio",
                                      {
                                        attrs: {
                                          value: _vm.templateOptions[2].value,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.templateOptions[2].text)
                                        ),
                                      ]
                                    ),
                                    _c("b-select", {
                                      staticClass: "ml-4 mt-1",
                                      attrs: {
                                        disabled:
                                          _vm.isProfileExamples === false,
                                        options: _vm.exampleProfiles,
                                      },
                                      model: {
                                        value: _vm.selectedProfileExample,
                                        callback: function ($$v) {
                                          _vm.selectedProfileExample = $$v
                                        },
                                        expression: "selectedProfileExample",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "b-row",
                  { staticClass: "text-center mt-4" },
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mt-2",
                            attrs: { variant: "link" },
                            on: { click: _vm.clearSelection },
                          },
                          [_vm._v(_vm._s(_vm.t.CV_Tool_Cancel))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm.setupStep === 2 && _vm.canHaveMotivationalTexts === true
        ? [
            _c(
              "b-card-body",
              [
                _c("b-card-title", { staticClass: "h5" }, [
                  _vm._v(_vm._s(_vm.t.CV_Tool_Adjust_Content)),
                ]),
                _c("b-card-text", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.t.CV_Tool_Adjust_Content_Description)),
                ]),
                _c(
                  "div",
                  { staticClass: "p-2" },
                  [
                    _c(
                      "b-form-radio-group",
                      {
                        staticClass: "mt-4",
                        attrs: { stacked: "" },
                        on: {
                          change: function ($event) {
                            return _vm.changeUseMotivationalTexts()
                          },
                        },
                        model: {
                          value: _vm.useMotivationalTexts,
                          callback: function ($$v) {
                            _vm.useMotivationalTexts = $$v
                          },
                          expression: "useMotivationalTexts",
                        },
                      },
                      [
                        _c(
                          "b-form-radio",
                          { staticClass: "mb-3", attrs: { value: false } },
                          [
                            _vm._v(
                              _vm._s(_vm.t.CV_Tool_Profiletext_Radiobutton)
                            ),
                          ]
                        ),
                        _c(
                          "b-form-radio",
                          { staticClass: "mb-3 mt-5", attrs: { value: true } },
                          [
                            _vm._v(
                              _vm._s(_vm.t.CV_Tool_Motivational_Radiobutton)
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm.useMotivationalTexts === true
                      ? [
                          _c(
                            "b-form",
                            [
                              _vm.isValidSection("TR_RESUME")
                                ? [
                                    _c("b-form-input", {
                                      staticClass: "plain-input border",
                                      class:
                                        _vm.motivationalHeadline.length > 199
                                          ? "border-danger"
                                          : "border-gray",
                                      attrs: {
                                        placeholder:
                                          _vm.t
                                            .CV_Tool_Motivational_Headline_Placeholder,
                                        maxLength: "200",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.changeMotivationalHeadline(
                                            $event
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.motivationalHeadline,
                                        callback: function ($$v) {
                                          _vm.motivationalHeadline = $$v
                                        },
                                        expression: "motivationalHeadline",
                                      },
                                    }),
                                    _vm.motivationalHeadline.length > 199
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center mt-1 ml-2",
                                          },
                                          [
                                            _c("b-icon", {
                                              attrs: {
                                                icon: "exclamation-circle",
                                                variant: "danger",
                                              },
                                            }),
                                            _c(
                                              "b-label",
                                              {
                                                staticClass: "text-danger ml-2",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.t
                                                      .CV_Tool_Motivational_Headline_Validation_Text
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                              _vm.isValidSection("PROFILE_RESUME")
                                ? [
                                    _c("b-form-textarea", {
                                      staticClass: "border mt-2",
                                      class:
                                        _vm.motivationalText.length > 1999
                                          ? "border-danger"
                                          : "border-gray",
                                      attrs: {
                                        placeholder:
                                          _vm.t
                                            .CV_Tool_Motivational_Text_Placeholder,
                                        "no-resize": "",
                                        rows: "10",
                                        maxLength: "2000",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.changeMotivationalText(
                                            $event
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.motivationalText,
                                        callback: function ($$v) {
                                          _vm.motivationalText = $$v
                                        },
                                        expression: "motivationalText",
                                      },
                                    }),
                                    _vm.motivationalText.length > 1999
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center mt-1 ml-2",
                                          },
                                          [
                                            _c("b-icon", {
                                              attrs: {
                                                icon: "exclamation-circle",
                                                variant: "danger",
                                              },
                                            }),
                                            _c(
                                              "b-label",
                                              {
                                                staticClass: "text-danger ml-2",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.t
                                                      .CV_Tool_Motivational_Text_Validation_Text
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.isSaving === true
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "position-absolute",
                                            staticStyle: {
                                              right: "0",
                                              "margin-top": "-22px",
                                              "margin-right": "30px",
                                            },
                                          },
                                          [
                                            _c("b-spinner", {
                                              staticStyle: {
                                                width: "20px",
                                                height: "20px",
                                              },
                                              attrs: { label: "Spinning" },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.savedFailed === true
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "position-absolute",
                                            staticStyle: {
                                              right: "0",
                                              "margin-top": "-18px",
                                              "margin-right": "10px",
                                            },
                                          },
                                          [
                                            _c("b-icon", {
                                              attrs: {
                                                icon: "x",
                                                variant: "danger",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm.savedComplete === true
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "position-absolute",
                                            staticStyle: {
                                              right: "0",
                                              "margin-top": "-18px",
                                              "margin-right": "10px",
                                            },
                                          },
                                          [
                                            _c(
                                              "BaseIcon",
                                              {
                                                attrs: {
                                                  width: "40",
                                                  height: "40",
                                                },
                                              },
                                              [_c("SaveCloud")],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        : [
            _c(
              "ColorThemePicker",
              {
                attrs: {
                  selected: _vm.selected,
                  title: _vm.t.CV_Tool_Color_Theme_Title,
                  text: _vm.t.CV_Tool_Color_Theme_Description,
                },
              },
              [
                _c(
                  "b-row",
                  { staticClass: "text-center mt-4" },
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mt-2",
                            attrs: { variant: "link" },
                            on: { click: _vm.clearSelection },
                          },
                          [_vm._v(_vm._s(_vm.t.CV_Tool_Cancel))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }